const LEGACY_LOCAL_STORAGE_KEYS = [
  "token",
  "accessToken",
  "authToken",
  "email",
  "mainTenantId",
  "tenantId",
  "_id",
  "userName",
  "role",
  "orgCode",
  "organization",
  "selectedTenantId",
  "selectedOrgCode",
  "selectedOrganization",
  "isSetupCompleted",
  "isFirstTimeUser",
  "i18nextLng",
  "JWT",
  "mayaAuthSessionId",
  "mayaProfileBootstrapSessionId",
  "mayaOrgSwitchNavigation",
  "mayaLastSuccessfulTokenRefreshAt",
  "mayaTokenRefreshLock",
  "dashboardInitialProfileFetchComplete",
  "analysisComparisonTab",
  "analysisSelectedPeople",
];

export const migrateLocalStorageToSessionStorage = () => {
  if (typeof window === "undefined") return;

  let sourceStorage;
  let targetStorage;

  try {
    sourceStorage = window.localStorage;
    targetStorage = window.sessionStorage;
  } catch {
    return;
  }

  LEGACY_LOCAL_STORAGE_KEYS.forEach((key) => {
    try {
      const value = sourceStorage.getItem(key);

      if (value === null) return;

      if (targetStorage.getItem(key) === null) {
        targetStorage.setItem(key, value);
      }

      sourceStorage.removeItem(key);
    } catch {
      // Ignore storage access issues.
    }
  });
};

migrateLocalStorageToSessionStorage();
